import { render, staticRenderFns } from "./QuocTichForm.vue?vue&type=template&id=24d05462&"
import script from "./QuocTichForm.vue?vue&type=script&lang=js&"
export * from "./QuocTichForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports